import * as React from 'react';

import {getTypeFromApiId} from 'nutshell-core/utils/get-type-from-api-id';

import {Checkbox} from 'shells/checkbox/checkbox';
// @ts-expect-error
import {getClasses} from 'shells/utils/get-classes';

import {NameCellContent} from './name-cell-content';

import styles from './name.module.css';

type Props = {
    cellData: any;
    isSelected: boolean;
    selection?: {
        onSelect: (arg1: any) => void;
        onShiftSelect: (arg1: any) => void;
    };
};

export class NameCell extends React.Component<Props> {
    getClasses = getClasses;

    shouldComponentUpdate(nextProps: Props) {
        return (
            nextProps.cellData !== this.props.cellData ||
            nextProps.isSelected !== this.props.isSelected
        );
    }

    render() {
        const isLoading = !this.props.cellData.links;
        const classes = this.getClasses('ui-entity-list-row ui-entity-list-row--name', {
            'ui-entity-list-row--loading': isLoading,
        });

        const content = isLoading ? (
            <div key='loading'>{this.renderNameSection({isLoading: true})}</div>
        ) : (
            <div key='loaded'>{this.renderNameSection({isLoading: false})}</div>
        );

        return <div className={classes}>{content}</div>;
    }

    renderNameSection({isLoading}: {isLoading: boolean}) {
        let entityType = this.props.cellData.links ? this.props.cellData.links.entity.type : null;
        // We decide what kind of element to render based on the type, but we don't know the type
        // until we get cellData.links, so we can use the page we're on to determine what kind
        // of loading state to show.
        if (!entityType && window.location.pathname === '/leads') {
            entityType = 'leads';
        }

        const type =
            this.props.cellData && this.props.cellData.id
                ? getTypeFromApiId(this.props.cellData.id)
                : undefined;

        return (
            <div
                className={
                    this.props.selection ? styles['name-cell'] : styles['name-cell--no-checkbox']
                }
            >
                {this.props.selection ? (
                    <div
                        onClick={(event: React.SyntheticEvent) => {
                            this.handleCheckboxClick(event);
                            this.handleSelectRowToggle(this.props.isSelected, event);
                        }}
                        style={type === 'mcfxCompanies' ? {cursor: 'default'} : undefined}
                        className={styles.checkbox}
                    >
                        <Checkbox
                            checked={this.props.isSelected}
                            onClick={this.handleCheckboxClick}
                            onChange={this.handleSelectRowToggle}
                            customCheckboxStyle={
                                // If selecting the row performs a function besides
                                // checking the checkbox (such as opening a sidebar)
                                // we want to use a default cursor here
                                type === 'mcfxCompanies' ? {cursor: 'default'} : undefined
                            }
                        />
                    </div>
                ) : undefined}
                <NameCellContent
                    cellData={this.props.cellData}
                    isLoading={isLoading}
                    entityType={entityType}
                />
            </div>
        );
    }

    handleCheckboxClick = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    };

    handleSelectRowToggle = (checked: boolean, event: React.SyntheticEvent) => {
        if (!this.props.selection) {
            return;
        }

        // @ts-expect-error
        if (event.nativeEvent.shiftKey) {
            this.props.selection.onShiftSelect(this.props.cellData.links.entity.id);
        } else {
            this.props.selection.onSelect(this.props.cellData.links.entity.id);
        }
    };
}
